export default __webpack_public_path__ + "static/media/light.94755771.svg";